import { motion } from 'framer-motion'

import { styled } from 'styled-system/jsx'

const Backdrop = styled(motion.div, {
  base: {
    position: 'fixed',
    inset: '0',
    backgroundColor: 'rgba(26, 19, 48, 0.45)',
    zIndex: '105',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
})

const Card = styled(motion.div, {
  base: {
    width: '100%',
    maxWidth: '720px',
    maxHeight: '88vh',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    boxShadow: '0 28px 80px -20px rgba(26, 19, 48, 0.32)',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
})

const Header = styled('header', {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingX: '22px',
    paddingY: '16px',
    borderBottom: '1px solid',
    borderColor: '#F0EDFA',
  },
})

const Title = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '20px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.3px',
  },
})

const CloseButton = styled('button', {
  base: {
    width: '36px',
    height: '36px',
    borderRadius: 'pill',
    border: 'none',
    backgroundColor: 'quickpass.surfaceCool',
    color: 'quickpass.inkSoft',
    fontSize: '18px',
    lineHeight: '1',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition:
      'background-color {durations.fast} {easings.appleStandard}, color {durations.fast} {easings.appleStandard}',
    _hover: {
      backgroundColor: 'quickpass.warmth',
      color: '#FFFFFF',
    },
  },
})

const Body = styled('div', {
  base: {
    overflowY: 'auto',
    padding: '20px 22px',
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
  },
})

const TitleStrip = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: '120px 1fr 1fr',
    gap: '14px',
    paddingBottom: '14px',
    borderBottom: '1px solid',
    borderColor: '#F0EDFA',
  },
})

const SideTitle = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '14px',
    fontWeight: '700',
    color: 'quickpass.ink',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
})

const RowGrid = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: '120px 1fr 1fr',
    gap: '14px',
    alignItems: 'center',
    paddingY: '8px',
    borderBottom: '1px solid',
    borderColor: '#F8F6FF',
  },
})

const RowLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '700',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    color: 'quickpass.inkSoft',
  },
})

const Cell = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '14px',
    fontWeight: '600',
    color: 'quickpass.ink',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
  },
  variants: {
    isWinner: {
      true: {
        color: 'quickpass.success',
      },
    },
  },
})

const WinnerGlyph = styled('span', {
  base: {
    fontSize: '12px',
    lineHeight: '1',
  },
})

export {
  Backdrop,
  Card,
  Header,
  Title,
  CloseButton,
  Body,
  TitleStrip,
  SideTitle,
  RowGrid,
  RowLabel,
  Cell,
  WinnerGlyph,
}
